import styled from 'styled-components';
var SliderDotList = styled.ul.withConfig({
  displayName: "SliderDotList",
  componentId: "sc-1ttytzt-0"
})(["margin:0;padding:0;li{cursor:pointer;display:inline-block;margin:0 0.3125rem;padding:0;position:relative;}"]);
export default SliderDotList;